import React, { Component } from "react";
import { ThumbnailLocal } from "./Thumbnail";
import accepts from "attr-accept";
import Compressor from "compressorjs";
import { Button, Label } from "reactstrap";
import Humanize from "humanize-plus";

const ACCEPT =
    "image/jpeg,image/png,image/bmp," + // .jpg .jpeg .png .bmp
    ".txt," + // .txt
    "text/csv,.csv," + // .csv
    "application/pdf," + // .pdf
    "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document," + // .doc .docx
    "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; // .xls .xlsx

export class ArchivoUpload extends Component {
    constructor(props) {
        super(props);
        this.input = React.createRef();
        this.state = {};
        let maxFileSize = "18MB" + "";
        if (maxFileSize.indexOf("MB") >= 0) {
            maxFileSize = maxFileSize.replace("MB", "") * 1024 * 1024; //(bytes) = 2MB
        }
        this.maxSize = maxFileSize;
    }

    onChange = () => {
        let index = this.props.index;
        let user = this.props.usuario;
        let fecha = new Date();
        let file = this.input.current.files || []; //controla que no tenga el elemento 0
        if (file.length > 0) {
            file = file[0];
        } else {
            file = null;
        }
        if (file) {
            let fileCom;
            const fileSizeCondition = this.maxSize && file.size ? file.size <= this.maxSize : true;
            const comprimir = async () => {
                if (accepts(file, ACCEPT) && fileSizeCondition) {
                    fileCom = file;
                } else if (accepts(file, ACCEPT) && file.type.toString().toLowerCase().indexOf("image") >= 0) {
                    const compres = await new Promise((resolve, reject) => {
                        new Compressor(file, {
                            maxWidth: 2000,
                            convertSize: 2000000,
                            success(result) {
                                resolve(result);
                            },
                            error(error) {
                                console.log("Error", error);
                                reject(null);
                            },
                        });
                    });
                    if (compres) {
                        fileCom = compres;
                    } else {
                        fileCom = null;
                        this.alert.current.show_error("La imagen no pudo ser cargada.");
                    }
                }
            };
            comprimir().then(() => {
                if (fileCom) {
                    this.props.setFieldValue(`items[${index}].doc`, fileCom);
                    this.props.setFieldValue(`items[${index}].index`, index);
                    this.props.setFieldValue(`items[${index}].name`, file.name);
                    this.props.setFieldValue(`items[${index}].metadato.dsc`, file.name);
                    this.props.setFieldValue(`items[${index}].metadato.fecha`, fecha);
                    this.props.setFieldValue(`items[${index}].metadato.idUsuario`, user.id);
                    this.props.setFieldValue(`items[${index}].metadato.username`, user.usuario);
                }
            });
        }
    };

    render() {
        let values = this.props.values;
        return (
            <>
                {values.doc && <ThumbnailLocal archivo={values.doc} control={true} />}
                <Button
                    type="button"
                    color="primary"
                    className="thumbnail form-control st-405 "
                    onClick={() => this.input.current.click()}
                >
                    Seleccionar Documento
                </Button>

                <div className={"jedai-dd"}>
                    <div className={"ddx"}>
                        <input type="file" accept={ACCEPT} ref={this.input} onChange={this.onChange} />
                    </div>
                    <button type="button" className="form-control mt-1" onClick={() => this.input.current.click()}>
                        Agregar {this.maxSize ? `(máximo ${Humanize.fileSize(this.maxSize)})` : ""}
                    </button>
                </div>
                <br />
                <small>
                    <Label className="text-primary">Máximo 18.00 MB</Label>
                </small>
            </>
        );
    }
}
